/** @format */

// @mui
import * as React from "react";
import { ChangeEvent, useState, useEffect } from "react";

import {
    Grid,
    Card,
    CardHeader,
    TextField,
    Button,
    MenuItem,
    FormControl,
    InputLabel,
    Radio,
    Box,
    Select,
    IconButton,
    FormHelperText,
    CircularProgress,
} from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment'
import { useParams, useNavigate } from "react-router-dom";
import FileUpload from "../../components/FileUpload";
import moment from "moment";

//Api Import
import {
    viewNoteDate,
    postDate,
} from "../../store/services/roleService";

// ** Third Party Imports
import * as yup from "yup";
import toast from "react-hot-toast";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";

// Icon Imports
import DoneIcon from "@mui/icons-material/Done";
// components
import Page from "../../components/Page";
import axios from 'axios'

const schema = yup.object().shape({
    name: yup.string().required("Name is requierd"),
});


const CreateUser = () => {
    const navigate = useNavigate();
    const routeParams = useParams();
    const [role, setRole] = useState([]);


    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const onSubmit = (params) => {
        console.log("Params",params);
        postDate(routeParams.id,{note:params.note,expiry_date:expiryValue,_method:'PUT'})
        .then((r) => {console.log(r);
            toast.success("User Create Successfully!");
            setTimeout(function () {
                navigate("/device-info");
            }, 2000);
        })
        .catch((error) => {
            console.log(error);
            toast.success(error.response.data.message);
        })
    
    };	

    useEffect(() => {
        getRolePermission();
    }, []);

    const getRolePermission = async() => 
    {
        const response = await axios.get('http://localhost:8000/api/vista/getRole');
        setRole(response.data);
    }

    const handleBackPage = () => {
        navigate("/device-info");
    };


    return (
        <Page className="User Overview" title="Create User">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Card className="RoleCard">
                                <CardHeader title="Note" className="RolePageHeading" />
                                <Grid container spacing={2} className="RoleCardBody">
                                    <Grid item xs={12}>
                                        <Box className="BoxWidth">
                                            <FormControl fullWidth>
                                                <Controller
                                                    name="name"
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            onChange={onChange}
                                                            label="Name"
                                                            placeholder="Full Name"
                                                            error={Boolean(errors.name)}
                                                            aria-describedby="validation-schema-name"
                                                        />
                                                    )}
                                                />
                                                {errors.name && (
                                                    <FormHelperText
                                                        sx={{ color: "error.main" }}
                                                        id="validation-schema-name">
                                                        {errors.name.message}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>

                                        <Box className="BoxWidth">
                                            <FormControl fullWidth>
                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            onChange={onChange}
                                                            label="Email"
                                                            placeholder="Email"
                                                            error={Boolean(errors.email)}
                                                            aria-describedby="validation-schema-email"
                                                        />
                                                    )}
                                                />
                                                {errors.email && (
                                                    <FormHelperText
                                                        sx={{ color: "error.main" }}
                                                        id="validation-schema-email">
                                                        {errors.email.message}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>

                                        <Box className="BoxWidth">
                                            <FormControl fullWidth>
                                                <Controller
                                                    name="password"
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            type="password"
                                                            value={value}
                                                            onChange={onChange}
                                                            label="Password"
                                                            placeholder="Password"
                                                            error={Boolean(errors.password)}
                                                            aria-describedby="validation-schema-password"
                                                        />
                                                    )}
                                                />
                                                {errors.password && (
                                                    <FormHelperText
                                                        sx={{ color: "error.main" }}
                                                        id="validation-schema-password">
                                                        {errors.password.message}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>

                                        <Box className="BoxWidth">
                                            <FormControl fullWidth>
                                                <Controller
                                                    name="phone"
                                                    control={control}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange } }) => (
                                                        <TextField
                                                            value={value}
                                                            onChange={onChange}
                                                            label="Phone Number"
                                                            placeholder="Phone Number"
                                                            error={Boolean(errors.phone)}
                                                            aria-describedby="validation-schema-phone"
                                                        />
                                                    )}
                                                />
                                                {errors.phone && (
                                                    <FormHelperText
                                                        sx={{ color: "error.main" }}
                                                        id="validation-schema-phone">
                                                        {errors.phone.message}
                                                    </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>

                                        <Box className="BoxWidth">
                                            <FormControl fullWidth>
                                              <select className="form-control" name="role_id">
                                                <option>Choose an role</option>
                                                {
                                                    role.map((item) => {
                                                        return(
                                                            <>
                                                            <option value={item.id}>{item.permission_name}</option>
                                                            </>
                                                        )
                                                    })
                                                }
                                              </select>
                                            </FormControl>
                                        </Box>
                                    </Grid>

                                    <Grid
                                    item
                                    container
                                    justifyContent="space-between"
                                    alignItems="center"
                                    xs={12}>
                                    <Button
                                        variant="outlined"
                                        onClick={handleBackPage}
                                        className="DeleteButton">
                                        Back
                                    </Button>

                                    <Button
                                        variant="contained"
                                        type="submit"
                                        className="SaveButton"
                                        startIcon={<DoneIcon />}>
                                        Submit
                                    </Button>
                                </Grid>

                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                </form>
        </Page>
    );
};
export default CreateUser;